/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardStandingStream } from './LeaderboardStandingStream';
import {
    LeaderboardStandingStreamFromJSON,
    LeaderboardStandingStreamFromJSONTyped,
    LeaderboardStandingStreamToJSON,
    LeaderboardStandingStreamToJSONTyped,
} from './LeaderboardStandingStream';

/**
 * 
 * @export
 * @interface LeaderboardStandingEntry
 */
export interface LeaderboardStandingEntry {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardStandingEntry
     */
    rank?: number;
    /**
     * Stable cross-endpoint identifier. Returned ONLY for the authenticated caller's own row on this public endpoint — omitted otherwise to prevent userId enumeration.
     * @type {string}
     * @memberof LeaderboardStandingEntry
     */
    userId?: string;
    /**
     * True when this row corresponds to the authenticated caller.
     * @type {boolean}
     * @memberof LeaderboardStandingEntry
     */
    isMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardStandingEntry
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardStandingEntry
     */
    avatarUrl?: string;
    /**
     * Tier id — drives the shared avatar's tier ring.
     * @type {string}
     * @memberof LeaderboardStandingEntry
     */
    subscriptionTier?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardStandingEntry
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardStandingEntry
     */
    eventCount?: number;
    /**
     * Rank at the previous ranking computation. Absent on snapshot (historical) standings.
     * @type {number}
     * @memberof LeaderboardStandingEntry
     */
    previousRank?: number;
    /**
     * Signed movement since the previous ranking computation (positive = climbed). Absent on snapshot standings.
     * @type {number}
     * @memberof LeaderboardStandingEntry
     */
    rankChange?: number;
    /**
     * Event counts keyed by event type ID — the per-row scoring breakdown. Absent on snapshot standings.
     * @type {{ [key: string]: number; }}
     * @memberof LeaderboardStandingEntry
     */
    eventCountsByType?: { [key: string]: number; };
    /**
     * Epoch ms of the row's last counted event. Absent on snapshot standings and on paid rows with no events yet.
     * @type {number}
     * @memberof LeaderboardStandingEntry
     */
    lastEventAt?: number;
    /**
     * 
     * @type {LeaderboardStandingStream}
     * @memberof LeaderboardStandingEntry
     */
    stream?: LeaderboardStandingStream;
}

/**
 * Check if a given object implements the LeaderboardStandingEntry interface.
 */
export function instanceOfLeaderboardStandingEntry(value: object): value is LeaderboardStandingEntry {
    return true;
}

export function LeaderboardStandingEntryFromJSON(json: any): LeaderboardStandingEntry {
    return LeaderboardStandingEntryFromJSONTyped(json, false);
}

export function LeaderboardStandingEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardStandingEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'] == null ? undefined : json['rank'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'isMe': json['isMe'] == null ? undefined : json['isMe'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'subscriptionTier': json['subscriptionTier'] == null ? undefined : json['subscriptionTier'],
        'value': json['value'] == null ? undefined : json['value'],
        'eventCount': json['eventCount'] == null ? undefined : json['eventCount'],
        'previousRank': json['previousRank'] == null ? undefined : json['previousRank'],
        'rankChange': json['rankChange'] == null ? undefined : json['rankChange'],
        'eventCountsByType': json['eventCountsByType'] == null ? undefined : json['eventCountsByType'],
        'lastEventAt': json['lastEventAt'] == null ? undefined : json['lastEventAt'],
        'stream': json['stream'] == null ? undefined : LeaderboardStandingStreamFromJSON(json['stream']),
    };
}

export function LeaderboardStandingEntryToJSON(json: any): LeaderboardStandingEntry {
    return LeaderboardStandingEntryToJSONTyped(json, false);
}

export function LeaderboardStandingEntryToJSONTyped(value?: LeaderboardStandingEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'userId': value['userId'],
        'isMe': value['isMe'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'subscriptionTier': value['subscriptionTier'],
        'value': value['value'],
        'eventCount': value['eventCount'],
        'previousRank': value['previousRank'],
        'rankChange': value['rankChange'],
        'eventCountsByType': value['eventCountsByType'],
        'lastEventAt': value['lastEventAt'],
        'stream': LeaderboardStandingStreamToJSON(value['stream']),
    };
}

